async function LoadArsenalViewer(model) {
  (async function(ar, s, e) {
    const token = window.App?.config?.arsenalToken
      || document.getElementById('application-settings')?.dataset?.arsenalToken

    if (!token) {
      console.warn('Arsenal token missing. Viewer will not initialize.')
      return
    }

    ar.arsenal = [
      {
        uid: model.uid,
        user: 'cgtrader_enterprise',
        target: '.arsenal-viewer',
        viewer: '3D',
        gltf: model.gltf,
        usdz: model.usdz,
        preview: model.preview,
        name: model.name,
        token,
      },
    ]
    const body = s.querySelector('body')
    const scriptTag = s.createElement('script')
    scriptTag.async = 1
    scriptTag.src = `${e}@1`
    body.appendChild(scriptTag)
  })(window, document, 'https://unpkg.com/cgloader')
}

export default LoadArsenalViewer
